import { toBRL } from "@/utils/formatters/formatCurrency";
import { StorePrice } from "../StorePrice";
import { StoreStars } from "../StoreStars";
import styles from "./styles.module.scss";

export interface StorePromotionItem {
  key: string;
  name: string;
  images: string[];
  originalAmount: number;
  finalAmount: number;
  selected: boolean;
  onToggle: () => void;
}

export function StorePromotions({ items }: { items: StorePromotionItem[] }) {
  if (items.length === 0) return null;

  return (
    <section className={styles.section} aria-labelledby="store-promotions-title">
      <div className={styles.heading}>
        <h2 id="store-promotions-title">Produtos em promoção</h2>
        <p>Os produtos mais procurados com descontos imperdíveis.</p>
      </div>

      <div className={styles.grid}>
        {items.map((item) => (
          <article className={styles.card} key={item.key}>
            <div className={styles.images} data-count={item.images.length}>
              {item.images.map((src, index) => <img key={`${src}-${index}`} src={src} alt={index === 0 ? item.name : ""} loading="lazy" decoding="async" />)}
            </div>
            <h3>{item.name}</h3>
            <StoreStars />
            <StorePrice originalAmount={item.originalAmount} finalAmount={item.finalAmount} size="large" />
            <button className={styles.button} type="button" onClick={item.onToggle} aria-pressed={item.selected} aria-label={`${item.selected ? "Remover" : "Comprar"} ${item.name} — ${toBRL(item.finalAmount)}`}>
              {item.selected ? "No carrinho" : "Comprar agora"}
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}
